import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Buscar última atualização dos dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getUltimaAtualizacao(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/ultima-atualizacao-dos-dados/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(item) {
  return ''
}

export function getRadius(item) {
  let population = item.cadastros_esus
  const minRadius = 10
  const maxRadius = 100
  const minPopulation = 0
  const maxPopulation = 10000

  // Ensure that the population is within bounds
  if (population < minPopulation) population = minPopulation
  if (population > maxPopulation) population = maxPopulation

  // Calculate the radius using linear interpolation
  let radius =
    minRadius +
    ((population - minPopulation) / (maxPopulation - minPopulation)) *
      (maxRadius - minRadius)
  return radius
}

export function getRadiusColor(item) {
  let cadastros_esus = Number(item.cadastros_esus)
  let cadSisab = Number(item.cad_sisab)
  let minCad = Number(item.min_cad)
  let maxCad = Number(item.max_cad)

  if (cadastros_esus < minCad) {
    return 'orange'
  } else if (cadastros_esus >= minCad && cadastros_esus <= maxCad) {
    return 'green'
  } else {
    return 'red'
  }
}

export function getRowColorTabelaPessoasPorEquipe(item) {
  if (Number(item.cadastros_esus) < Number(item.min_cad)) {
    return 'orange'
  } else if (
    Number(item.cadastros_esus) >= Number(item.min_cad) &&
    Number(item.cadastros_esus) <= Number(item.max_cad)
  ) {
    return 'green'
  } else {
    return 'red'
  }
}
